// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
import GlobalController from "./global_controller"
import InstabookController from "./instabook_controller"
import GoogleMapsController from "./google_maps_controller"

application.register("hello", HelloController)
application.register("global", GlobalController)
application.register("instabook", InstabookController)
application.register("google-maps", GoogleMapsController)
